import fileSizeToString from '@/utils/helpers/fileSizeToString';

export default (fileSize) => fileSizeToString(fileSize);
